import { useShallow } from 'zustand/shallow'

import { Button } from '@/components/atoms/Button'
import { useI18n } from '@/locales/client'
import useDialogsStore from '@/stores/DialogsStore'

const SendMySelfButton = () => {
  const t = useI18n()
  const toggle = useDialogsStore(useShallow(state => state.toggle))
  const handleClick = () => {
    toggle('sendMyself')
  }

  return (
    <Button className="my-5 text-center text-base font-semibold" onClick={handleClick}>
      {t('sendMyselfButton')}
    </Button>
  )
}

export default SendMySelfButton
